import { SettingTask } from "../../classes";
// import moment from "moment";
const SettingTaskModule = {
  namespaced: true,
  state: {
    settingTasks: [],
    settingTask: null,
    countSettingTasks: 0
  },
  actions: {
    getSettingTasks: async ({ commit, rootGetters }, payload) => {
      payload.marketId = rootGetters["markets/getMarketId"] ? rootGetters["markets/getMarketId"] : payload.marketId
      try {
        // commit("setCountSettingTask", 0);
        const data = await SettingTask.getSettingTasks(payload);
        commit("setSettingTasks", { settingTasks: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    getSettingTasksByMarketSmall: async ({ commit, rootGetters }, payload) => {
      payload.marketId = rootGetters["markets/getMarketId"] ? rootGetters["markets/getMarketId"] : payload.marketId
      try {
        commit("setCountSettingTask", 0);
        const data = await SettingTask.getSettingTasksByMarketSmall(payload);
        commit("setCountSettingTask", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getSettingTask: async ({ commit }, payload) => {
      try {
        const data = await SettingTask.getSettingTask({ id: payload.id });
        commit("setSettingTask", { settingTask: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createSettingTask: async ({ commit, rootGetters }, payload) => {
      let marketId = rootGetters["markets/getMarketId"] ? rootGetters["markets/getMarketId"] : payload.marketId
      try {
        const newObj = {
          ...payload,
          marketId,
        };
        const data = await SettingTask.createSettingTask(newObj);
        commit("setSettingTask", { settingTask: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateSettingTask: async ({ commit }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await SettingTask.updateSettingTask(newObj);
        commit("setSettingTask", { settingTask: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateSettingTasks: async ({ commit }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await SettingTask.updateSettingTasks(newObj);
        // commit("setSettingTasks", { settingTasks: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    removeSettingTask: async ({ commit }, payload) => {
      try {
        const data = await SettingTask.removeSettingTask({ id: payload.id });
        commit("removeSettingTask");
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getSettingTasks: state =>
      state.settingTasks,
    getSettingTask: state =>
      state.settingTask,
    countSettingTasks: state => state.countSettingTasks
  },
  mutations: {
    setSettingTasks: (state, payload) => {
      state.settingTasks = payload.settingTasks;
    },
    setSettingTask: (state, payload) => {
      state.settingTask = payload.settingTask;
    },
    setCountSettingTask: (state, payload) => {
      state.countSettingTasks = payload;
    },
    removeSettingTask: (state) => {
      state.settingTask = null;
    },
  }
};
export default SettingTaskModule;
